import { CriticalAreaModel } from "src/app/template/critical-area-window/critical-area.model";
import { WorkableElement } from "../SectionElements/WorkableElement";
import * as THREE from '@phdsoft/three';

export class CriticalAreaElement extends WorkableElement {

  constructor(id: string, target: WorkableElement, mesh: any, material: THREE.Material) {
    super(mesh, material, id);
    this.Guid = id;
    this.regionId = target.regionId
    this.regionIds = target.regionIds
    this.SectionId = target.SectionId
    this.elementTypeName = 'CriticalAreaElement';
  }

  public _CriticalAreaProperties: CriticalAreaModel;
  public get CriticalAreaProperties(): CriticalAreaModel {
    return this._CriticalAreaProperties;
  }
  public set CriticalAreaProperties(v: CriticalAreaModel) {
    this._CriticalAreaProperties = v;
    this.date = this._CriticalAreaProperties.DateStarted;
  }

  public VerifyProperties() {
    throw new Error("Method not implemented.");
  }
}